{
  "startne": {
    "main": {
      "title": "CAMO Inspections - Start Lists",
      "titleMotorna": "Powered Aircraft",
      "titleJadralna": "Gliders",
      "titleUltralight": "Ultralight"
    },
    "buttons": {
      "nazaj": "Back",
      "nazajGlavni": "Main Menu",
      "natisni": "Print",
      "poslji": "Send",
      "brisiIzbiro": "Delete"
    },
    "nav": {
      "jadralna": "CAMO Inspections - Glider Start Lists",
      "motorna": "CAMO Inspections - Powered Aircraft Start Lists",
      "ultralight": "CAMO Inspections - Ultralight Start Lists"
    },
    "labels": {
      "datumOd": "Date FROM:",
      "datumDo": "Date TO:",
      "klubL": "Select aircraft club:",
      "klubP": "Select pilot club:",
      "namen": "Select purpose:",
      "naloga": "Select task:",
      "pilot": "Select pilot:",
      "reg": "Select aircraft registration:",
      "stPristankov": "No. of landings:",
      "stLetov": "No. of flights:",
      "casVZraku": "Time in air:"
    },
    "data": {
      "title": "Data",
      "stPristankov": "No. of landings:",
      "stLetov": "No. of flights:",
      "casVZraku": "Duration:"
    },
    "table": {
      "reg": "REG",
      "vzlet": "TAKE-OFF",
      "pilot": "PILOT",
      "trajanje": "DURATION",
      "naloga": "TASK",
      "datum": "DATE",
      "odklop": "RELEASE",
      "pristanek": "LANDING",
      "titleM": "POWERED FLIGHTS",
      "titleJ": "GLIDER FLIGHTS",
      "titleU": "ULTRALIGHT FLIGHTS"
    }
  }
}